import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Mic = createReactComponent("Mic", ["svg", defaultAttributes, [["path", {
  d: "M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z",
  key: "6jm2uq"
}], ["path", {
  d: "M19 10v2a7 7 0 01-14 0v-2",
  key: "1dkhyo"
}], ["line", {
  x1: "12",
  y1: "19",
  x2: "12",
  y2: "23",
  key: "2d2mwp"
}], ["line", {
  x1: "8",
  y1: "23",
  x2: "16",
  y2: "23",
  key: "52tlcf"
}]]]);
export default Mic;